import { Modal, Button } from 'react-bootstrap'
const ConfirmModal =(props) =>{
        return (
            <Modal
                show={props.showModal}
                dialogClassName="validated-name-signature-modal-dialog"
                backdropClassName="veil"
                animation={false}
                centered
                autoFocus={false}
                onHide={props.handleConfirmClose}
            >
                <Modal.Header closeButton>
                    <Modal.Title style={{ display: 'inline-block' }}>
                        {props.title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form className="form-inline">
                        <div className="form-group">
                           {props.message}
                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={props.handleConfirmClose}>
                        No
                    </Button>
                    <Button variant="primary" onClick={props.handleConfirmClick}>
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>
        )
}

export default ConfirmModal